import React from 'react';
import MainVideo from '../../components/mainVideo/MainVideo';

const Video = () => {
    return (
        <>
            <MainVideo />
        </>
    );
};

export default Video;